const baseContent = {
  type: "color",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "howToPlay",
    file: {},
    isUpdated: false,
    colorMix: {
      flag: true,
      color1: "#000000",
      color2: "#000000",
      isUpdated: false,
    },
  },
  translation: {
    id: "",
    name: "",
    translationableId: "",
    translationableType: "Resource",
    adminId: "",
    languageId: "",
    flag: false,
    isUpdated: false,
  },
};

const createBackgroundColorEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseContent,
    data: {
      ...baseContent.data,
      key,
    },
    translation: {
      ...baseContent.translation,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: false,
});

const backgroundColorEntries = [
  { title: "Background Colors", key: "mockScreenBackgroundColors" },
];

const backgroundColor = backgroundColorEntries.map(({ title, key }) => createBackgroundColorEntry(title, key));

export { backgroundColor };
